import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { ClusterRequest } from '../../types/cluster'

const useCreateNewCluster = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (newCluster: ClusterRequest) =>
			api.clusters.createNewCluster(newCluster),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['clusters'] })
		}
	})
}

export default useCreateNewCluster
